import { Injectable } from '@angular/core';
import { ImageProperties } from '@skyfit/core-data-library';

@Injectable({
  providedIn: 'root',
})
export class ImageUtilService {
  getImageDimensions(url: string): Promise<ImageProperties> {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        resolve({
          height: img.height,
          width: img.width,
        });
      };
      img.src = url;
    });
  }

  async getImageInfoFromFile(image: File): Promise<ImageProperties> {
    const fileSize = image.size / 1024;
    const url = URL.createObjectURL(image);
    const dimensions = await this.getImageDimensions(url.toString());
    URL.revokeObjectURL(url);
    return { ...dimensions, fileSize };
  }
}
